import React from 'react';

export default function LoadingBody(): React.ReactElement {
  const rows = [0, 1, 2, 3];
  return (
    <div className="bg-white rounded-lg border border-lineSoft px-5 py-2">
      {rows.map((i) => (
        <div
          key={i}
          className={`flex gap-3 items-center py-3.5 ${
            i < rows.length - 1 ? 'border-b border-lineSoft' : ''
          }`}
        >
          <div className="animate-pulse bg-lineSoft rounded-md h-3 w-2/5" />
          <div className="animate-pulse bg-lineSoft rounded-md h-3 w-1/5" />
          <div className="animate-pulse bg-lineSoft rounded-md h-3 w-[15%]" />
          <div className="animate-pulse bg-lineSoft rounded-md h-3 w-[10%]" />
        </div>
      ))}
    </div>
  );
}